import './App.css';
import React from 'react';
import { IconsSource } from 'ui-toolkit';
import { PineconeThemeProvider } from 'ui-toolkit/theming/PineconeThemeProvider';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { Worker } from '@react-pdf-viewer/core';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SpaRouter } from './router/SpaRouter';
import { EnvironmentVariablesWrapper } from './ui-toolkit/environmentVariables/EnvironmentVariablesWrapper';
import LoadingColorsApplier from './components/shared/LoadingColorsApplier';
import { FaviconUpdater } from './components/shared/FaviconUpdater';

const App: React.FC = () => {
  return (
    <PineconeThemeProvider>
      <IconsSource />
      <Worker workerUrl={`/spa/pdf.worker.js?v=${import.meta.env.VITE_VERSION}`} />
      <Provider store={store}>
        <EnvironmentVariablesWrapper>
          <LoadingColorsApplier />
          <FaviconUpdater />
          <ToastContainer limit={4} autoClose={5 * 1000} newestOnTop />
          <SpaRouter />
        </EnvironmentVariablesWrapper>
      </Provider>
    </PineconeThemeProvider>
  );
};

export default App;
